import { AfterViewInit, Component, DoCheck, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { FileUploader } from 'ng2-file-upload';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { InterfaceMappingService } from '../../../service/interface-mapping/interface-mapping.service';
import { config } from '../../../util/config';
import { FormControl } from '@angular/forms';
import { GridOptions } from 'ag-grid';
import { OwnerService } from '../../../service/owner/owner.service';
import { AgGridHelper } from '../../../util/AgGridHelper';

import * as xlsx from 'xlsx';

const URL = 'https://foo.bar.com';

@Component({
  selector: 'app-root',
  templateUrl: 'wa0051.component.html',
  styleUrls: ['wa0051.component.scss']
})
export class Wa0051Component implements AfterViewInit, DoCheck {
  public componentTitle = 'WA0051:データマッピング(定義作成1)';

  private working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public config = config;
  private production = environment.production;
  private backgroundColor: string;
  private updprogramCd = 'wa0051';

  private rowData;

  private uploadObjectId = null;
  private uploadobjects;
  private uploadobjects_objectname;

  private filetypes;

  private selectUploadObjectId: FormControl;

  private modeMappingPattern = 2;

  private uploadpatterns;

  private uploader: FileUploader;
  private hasBaseDropZoneOver: boolean;
  private hasAnotherDropZoneOver: boolean;
  private response: string;
  private errorInfo = '';

  private uploadObjectIdCls = '';
  private selectUploadObjectIdCls = '';
  private isSubmitButtonEnabled = false;
  private isShow0052 = false;
  private isShowSendLoading = false;

  /** owner select */
  public gridOptions: GridOptions;
  public ownerRowData: any[];
  private ownerGridHelper: AgGridHelper;
  @ViewChild('ownerGridView')
  ownerGridView: ElementRef;
  public selectedOwners = [];

  /** overlay for pattern */
  private isShowPatternOverlay = false;
  private isOverlayPatternSelectButtonEnabled = false;
  private isOverlayPatternClearButtonEnabled = false;
  public patternGridOptions: GridOptions;
  public patternRowData: any[];
  private patternGridHelper: AgGridHelper;
  @ViewChild('patternGridView')
  patternGridView: ElementRef;
  public patternSelectedRowCount = 0;

  constructor(private interfaceMappingService: InterfaceMappingService, 
    private commonService: CommonService, 
    private router: Router, 
    private dialogsService: DialogsService,
    private ownerService: OwnerService) {

    this.uploader = new FileUploader({
      url: URL,
      disableMultipart: true
    });
    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    this.response = '';

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.selectUploadObjectId = new FormControl('', [
    ]);
    this.initOwnerGrid()
    this.initPatternGrid()
  }

  // public hasAnotherDropZoneOver:boolean = false;

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
    // console.log(e);

    if (this.uploader.queue.length > 1) {
      let inputElement = <HTMLInputElement>document.getElementById('fileupload');
      inputElement.value = null;
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.uploader.clearQueue();
    }
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public onFileSelected() {

    let inputElement = <HTMLInputElement>document.getElementById('fileupload');
    inputElement.value = null;

    if (this.uploader.queue.length > 1) {
      let inputElement = <HTMLInputElement>document.getElementById('fileupload');
      inputElement.value = null;
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.uploader.clearQueue();
    }
  }

  ngAfterViewInit() {
    this.ownerGridHelper.el = this.ownerGridView;
    this.patternGridHelper.el = this.patternGridView;

    sessionStorage.removeItem('isShowOwnerSelect');
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;
    this.interfaceMappingService
      .uploadobjects()
      .then(outputJson => {
        this.working = false;
        console.log(outputJson);
        this.filetypes = outputJson.uploadobjects;
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

    this.ownerService.get()
      .then(res => {
        console.log(res)
        this.ownerRowData = res.owners;
      })
  }

  onUploadObjectChange(isResetMode) {
    this.errorInfo = '';
    if (isResetMode)
      this.modeMappingPattern = 2;

    let matchData = this.filetypes.filter(function (item, index) {
      // tslint:disable-next-line:triple-equals
      if (item.uploadObjectId == this) {
        return true;
      }
    }, this.uploadObjectId);

    if (matchData.length === 0) {
      this.errorInfo = 'マッピング種別を選択してください。';
      this.isSubmitButtonEnabled = false;
      return false;
    }
    sessionStorage.setItem('uploadobjects', JSON.stringify(matchData[0]));
    return true;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onSubmit() {
    this.isShowSendLoading = true;
    this.errorInfo = '';
    if (this.working === true) {
      return;
    }

    this.working = true;
    sessionStorage.removeItem('uploadpatternowners');

    if (this.uploader.queue.length < 1) {
      this.isShowSendLoading = false;
      this.errorInfo = 'ファイルを選択してください。';
      return;
    }

    if (this.modeMappingPattern == 0) {
      this.isShowSendLoading = false;
      this.errorInfo = 'マッピングパターンを選択してください。';
      return;
    }

    const f = this.uploader.queue[0].file.name.split('.');

    switch (f[f.length - 1].toLowerCase()) {
      case 'xls':
        // console.log(this.uploader.queue[0].file.type);
        break;
      case 'xlsx':
        // console.log(this.uploader.queue[0].file.type);
        break;
      case 'xlsm':
        // console.log(this.uploader.queue[0].file.type);
        break;
      case 'xlsb':
        // console.log(this.uploader.queue[0].file.type);
        break;
      case 'csv':
        // console.log(this.uploader.queue[0].file.type);
        break;
      default:
        this.isShowSendLoading = false;
        this.errorInfo = '読み込めるファイル形式ではありません。';
        return;
    }

    sessionStorage.setItem('modeMappingPattern', this.modeMappingPattern.toString());

    if (this.modeMappingPattern == 1) {
      // 定義ファイル読み込み

      // tslint:disable-next-line:prefer-const
      let matchData = this.uploadpatterns.filter(function (item, index) {
        // tslint:disable-next-line:triple-equals
        if (item.uploadObjectsPatternId == this) {
          return true;
        }
      }, this.selectUploadObjectId.value);

      if (matchData.length === 0) {
        this.isShowSendLoading = false;

        sessionStorage.removeItem('modeMappingPattern');
        sessionStorage.removeItem('uploadpattern');
        this.errorInfo = '読み込むデータマッピング定義を選択してください。';
        return;
      }
      sessionStorage.setItem('uploadpattern', JSON.stringify(matchData[0]));
    } else if (this.modeMappingPattern == 2) {
      // 新規マッピング
      sessionStorage.removeItem('uploadpattern');
    } else {
      this.isShowSendLoading = false;

      this.errorInfo = 'マッピングパターン処理エラー';
      return;
    }

    this.interfaceMappingService
      .excel2json(this.uploader.queue[0]._file)
      .then(outputJson => {
        sessionStorage.setItem('uploadpatternowners', JSON.stringify(this.selectedOwners.map(o => o.ownerId)));
        this.isShowSendLoading = false;

        sessionStorage.setItem('uploadfilename', this.uploader.queue[0].file.name);

        this.interfaceMappingService.data2json_data = outputJson.exel2json[0].data;
        this.interfaceMappingService.data2json_viewjson = outputJson.exel2json[1].viewjson;

        this.uploader.clearQueue();
        this.isShow0052 = true;
      })
      .catch(error => {
        this.uploader.clearQueue();
        this.rowData = this.commonService.getErrorList(error);
        this.isShowSendLoading = false;
      });
  }

  ngDoCheck() {
    this.uploadObjectIdCls = (this.uploadObjectId !== null && this.uploadObjectId > 0) ? 'active' : '';
    this.selectUploadObjectIdCls = this.selectUploadObjectId.value + '' === '' ? '' : 'active';

    this.selectUploadObjectId.disable();  
    if (this.modeMappingPattern == 2) {
      this.selectUploadObjectIdCls = 'disabled';
    }
    else {
      this.selectUploadObjectIdCls = '';
    }

    this.isSubmitButtonEnabled =
      (this.uploadObjectId !== null && this.uploadObjectId !== 'null') &&
      this.uploader.queue.length > 0 &&
      (this.modeMappingPattern == 2 || (this.modeMappingPattern == 1 && (this.selectUploadObjectId.value + '').length > 0));

    if (this.uploader.queue.length > 1) {
      let inputElement = <HTMLInputElement>document.getElementById('fileupload');
      inputElement.value = null;
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.uploader.clearQueue();
    }
  }

  onDeleteAttachment(index) {
    this.errorInfo = '';
    this.uploader.removeFromQueue(this.uploader.queue[index]);
  }

  onClose0052(isRefreshGrid: boolean) {
    this.errorInfo = '';
    this.isShow0052 = false;
    this.working = false;

    if (isRefreshGrid) {
      this.selectedOwners = []
      this.selectUploadObjectId.setValue('')
      this.modeMappingPattern = 2;

      this.gridOptions.api.forEachNode((node) => {
        node.setSelected(false);
      })
    }
    // if (isRefreshGrid) this.onSubmit();
  }

  /** owner grid */
  initOwnerGrid () {
    this.ownerGridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: false,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      pagination: false,
      paginationPageSize: 0,
      onGridReady: params => {
        // this.gridApi = params;
        this.ownerGridHelper.onGridReady();
      },
      onRowDataChanged: () => {
        this.ownerGridHelper.onRowDataChanged();
      },
      onSelectionChanged: () => {
        const { api } = this.gridOptions;
        this.selectedOwners = [];
        api.getSelectedRows().forEach(r => {
          this.selectedOwners.push({
            ownerId: r.ownerId,
            ownerTx: r.ownerTx
          })
        })
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        width: 50,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'noCellFocus'],
        suppressMenu: true
      },
      {
        headerName: '',
        field: 'ownerTx',
        width: 350,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      }
    ];
    this.ownerGridHelper.setGridOptions(this.gridOptions);
  }

  /** overlay for pattern */
  initPatternGrid () {
    this.patternGridHelper = new AgGridHelper();
    // this.patternGridHelper.isOwnerNotFound = false;
    this.patternGridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      pagination: true,
      // paginationPageSize: 0,
      overlayLoadingTemplate: this.patternGridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.patternGridHelper.TEMPLATE_GRID_NODATA,
      onGridReady: params => {
        // this.gridApi = params;
        this.patternGridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.patternGridHelper.onGridFilterChanged();
        this.isOverlayPatternClearButtonEnabled = this.patternGridOptions.api.isAnyFilterPresent();
      },
      onRowDataChanged: () => {
        this.patternGridHelper.onRowDataChanged();
      },
      onSelectionChanged: () => {
        const { api } = this.patternGridOptions;
        this.patternSelectedRowCount = api.getSelectedRows().length;
        this.isOverlayPatternSelectButtonEnabled = this.patternSelectedRowCount > 0
      },
      postProcessPopup: params => {
        this.patternGridHelper.fixedAgMenu();
      }
    };
    this.patternGridOptions.columnDefs = [
      // {
      //   headerName: '',
      //   width: 50,
      //   checkboxSelection: true,
      //   suppressSorting: true,
      //   suppressFilter: true,
      //   cellClass: ['tc', 'noCellFocus'],
      //   suppressMenu: true
      // },
      {
        headerName: 'データマッピング名',
        field: 'patternName',
        width: 380,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: 380,
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      }
    ];
    this.patternGridHelper.setGridOptions(this.patternGridOptions);
  }
  showPatternOverlay () {
    if (!this.onUploadObjectChange(false)) {
      return;
    }

    this.patternRowData = null;
    this.isShowPatternOverlay = true;
    this.patternSelectedRowCount = 0;

    this.requestPatterns()
  }
  closePatternOverlay () {
    this.isShowPatternOverlay = false;
  }
  patternSelectInOverlay () {
    this.selectedOwners = [];

    const { api } = this.patternGridOptions;
    const row = api.getSelectedRows()[0]
    this.uploadpatterns = [
      ...(this.patternRowData)
    ]
    this.selectUploadObjectId.setValue(row.uploadObjectsPatternId);
    const { owners } = row;

    this.gridOptions.api.forEachNode((node) => {
      const { data } = node;
      node.setSelected(false);

      if (owners.length === 0) {
        return;
      }
      if (owners.filter(o => o.ownerId === data.ownerId).length > 0) {
        node.setSelected(true);
        this.selectedOwners.push({
          ownerId: data.ownerId,
          ownerTx: data.ownerTx,
        })
      }
    });
    this.closePatternOverlay()
  }
  onPatternOverlayClear () {
    this.patternGridOptions.api.setFilterModel(null);
  }
  requestPatterns () {
    let uploadObjects = sessionStorage.getItem('uploadobjects');
    uploadObjects = JSON.parse(uploadObjects);

    this.interfaceMappingService
      .uploadpattern(uploadObjects['uploadObjectId'])
      .then(outputJson => {
        this.working = false;

        console.log(outputJson);
        this.patternRowData = outputJson.uploadpatterns.map(u => {
          const result = {
            ...u
          }
          result.ownerTx = u.owners.map(o => o.ownerTx).join(', ')
          return result
        });
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
  onModeMappingPatternChange () {
    this.selectedOwners = []
    this.gridOptions.api.forEachNode((node) => {
      node.setSelected(false);
    });
    this.selectUploadObjectId.setValue('')
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0051/wa0051.component.ts